module.exports = __webpack_public_path__ + "media/images/ott_symbolic-5d1ee44aabe3bdefcc974e491cfef7ed.jpg";